import Material from '@primeng/themes/material';
import { definePreset } from '@primeng/themes';

/**
 * Shared PrimeNG theme preset for the Envolve app.
 *
 * Extracted from app.config.ts so it can be reused in environments that
 * bootstrap their own providers (e.g. Storybook preview) and stay in sync
 * with production theming.
 */
export const appThemePreset = definePreset(Material, {
  semantic: {
    primary: {
      50: '{indigo.50}',
      100: '{indigo.100}',
      200: '{indigo.200}',
      300: '{indigo.300}',
      400: '{indigo.400}',
      500: '{indigo.500}',
      600: '{indigo.600}',
      700: '{indigo.700}',
      800: '{indigo.800}',
      900: '{indigo.900}',
      950: '{indigo.950}',
    },
    focusRing: {
      width: '2px',
      style: 'dashed',
      color: '{primary.color}',
      offset: '1px',
    },
  },
});

/**
 * Standard providePrimeNG options used across the app. Mirrors app.config.ts so
 * Storybook renders components identically to production.
 */
export const appPrimeNGConfig = {
  ripple: false,
  inputStyle: 'filled' as const,
  theme: {
    preset: appThemePreset,
    options: { darkModeSelector: false },
  },
};
